var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconChangeNotactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    enableBackground: "new 0 0 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#484C52",
    points: "6.425,9.85 6.216,10.552 6.863,10.212 9.641,6.827 9.182,6.449  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484C52",
    d: "M14.468,3.398C13.239,1.67,11.41,0.525,9.321,0.172C8.88,0.098,8.433,0.061,7.99,0.061 c-3.883,0-7.17,2.783-7.818,6.618c-0.729,4.317,2.19,8.419,6.506,9.148c0.441,0.076,0.888,0.113,1.331,0.113 c3.881,0,7.17-2.784,7.817-6.618C16.179,7.23,15.697,5.126,14.468,3.398z M11.675,6.024l-4.006,4.878 c-0.008,0.01-0.022,0.015-0.03,0.023c-0.047,0.07-0.106,0.132-0.186,0.175l-1.857,0.979c-0.078,0.042-0.162,0.062-0.248,0.062 c-0.121,0-0.24-0.041-0.337-0.121c-0.166-0.136-0.232-0.357-0.171-0.562l0.599-2.013c0.024-0.084,0.073-0.154,0.131-0.213 c0.008-0.012,0.01-0.025,0.02-0.037l4.008-4.88c0.254-0.311,0.814-0.719,1.721,0.023c0.24,0.197,0.563,0.508,0.606,0.936 C11.941,5.457,11.912,5.737,11.675,6.024z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChangeNotactive);
export default __webpack_public_path__ + "static/media/icon-change-notactive.e0449602.svg";
export { ForwardRef as ReactComponent };